import SEO from "../components/SEO";
import ContactForm from "../components/ContactForm";
import MapComponent from "../components/MapComponent";
import { COMPANY } from "../data/content";

export default function KontaktPage() {
  return (
    <>
      <SEO
        title="Kontakt & Tidsbestilling"
        description="Kontakt Metteline Hjorth hos Hoofcare i Lemvig for at booke tid til certificeret hovtrimning af din hest. Vi kører i hele Jylland. Tlf. 26 21 00 13."
      />

      {/* Header Banner */}
      <section className="bg-forest-900 text-white py-14 lg:py-18">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-400">
            Book tid eller stil spørgsmål
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-sand-50">
            Kontakt Hoofcare
          </h1>
          <p className="text-sand-200 max-w-2xl text-base leading-relaxed">
            Jeg glæder mig til at høre fra dig. Ring, send en e-mail eller udfyld formularen herunder.
          </p>
        </div>
      </section>

      {/* Main Section */}
      <section className="py-16 bg-sand-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Contact Cards (5 cols) */}
            <div className="lg:col-span-5 space-y-6">
              
              <div className="bg-white p-6 sm:p-8 rounded-2xl border border-sand-300 shadow-xs space-y-6">
                <h2 className="text-xl font-bold text-forest-900 pb-3 border-b border-sand-200">
                  Kontaktoplysninger
                </h2>

                <div className="space-y-5 text-sm">
                  {/* Virksomhed & Adresse */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-forest-100 text-forest-800 flex items-center justify-center shrink-0 text-base">
                      <i className="fa-solid fa-location-dot"></i>
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-earth-700">Virksomhed & Adresse</p>
                      <p className="font-bold text-forest-900 text-base mt-0.5">{COMPANY.name}</p>
                      <p className="text-charcoal-700">{COMPANY.address}</p>
                      <p className="text-charcoal-700">{COMPANY.city}</p>
                      <p className="text-xs text-charcoal-600 mt-1">CVR: <strong className="font-semibold text-charcoal-800">{COMPANY.cvr}</strong></p>
                    </div>
                  </div>

                  {/* Telefon */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-forest-100 text-forest-800 flex items-center justify-center shrink-0 text-base">
                      <i className="fa-solid fa-phone"></i>
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-earth-700">Telefon</p>
                      <a
                        href={`tel:${COMPANY.phoneRaw}`}
                        className="text-forest-900 font-bold text-base hover:text-forest-700 transition-colors block mt-0.5 whitespace-nowrap cursor-pointer"
                      >
                        <span className="whitespace-nowrap">{COMPANY.phone}</span>
                      </a>
                      <p className="text-xs text-charcoal-600">Ring eller send SMS for hurtigt svar</p>
                    </div>
                  </div>

                  {/* Mail */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-forest-100 text-forest-800 flex items-center justify-center shrink-0 text-base">
                      <i className="fa-solid fa-envelope"></i>
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-earth-700">E-mail</p>
                      <a
                        href={`mailto:${COMPANY.email}`}
                        className="text-forest-900 font-bold text-base hover:text-forest-700 transition-colors block mt-0.5 whitespace-nowrap cursor-pointer"
                      >
                        <span className="whitespace-nowrap">{COMPANY.email}</span>
                      </a>
                    </div>
                  </div>

                  {/* Facebook */}
                  <div className="flex items-start gap-4 pt-2 border-t border-sand-200">
                    <div className="w-10 h-10 rounded-xl bg-blue-100 text-blue-800 flex items-center justify-center shrink-0 text-base">
                      <i className="fa-brands fa-facebook-f"></i>
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-earth-700">Følg med</p>
                      <a
                        href={COMPANY.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-900 font-bold text-sm hover:underline block mt-0.5 cursor-pointer flex items-center gap-1.5"
                      >
                        <span>Hoofcare på Facebook</span>
                        <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Coverage Highlight Box */}
              <div className="bg-forest-900 text-white p-6 rounded-2xl border border-forest-800 shadow-xs space-y-2">
                <div className="flex items-center gap-2 text-emerald-400 font-bold text-sm">
                  <i className="fa-solid fa-truck-ramp-box"></i>
                  <span>Kører i hele Jylland</span>
                </div>
                <p className="text-xs text-sand-200 leading-relaxed">
                  {COMPANY.coverageText}
                </p>
              </div>

            </div>

            {/* Form Column (7 cols) */}
            <div className="lg:col-span-7 space-y-4">
              <div>
                <h2 className="text-2xl font-bold text-forest-900">
                  Send en besked
                </h2>
                <p className="text-sm text-charcoal-600 mt-1">
                  Udfyld formularen med dine oplysninger og din hests placering i Jylland, så vender jeg tilbage hurtigst muligt.
                </p>
              </div>

              <ContactForm />
            </div>

          </div>

          {/* Map Section */}
          <div className="pt-8 border-t border-sand-300">
            <h3 className="text-xl font-bold text-forest-900 mb-4">
              Virksomhedens placering og dækningsområde i Jylland
            </h3>
            <MapComponent compact={false} />
          </div>

        </div>
      </section>
    </>
  );
}
